// extracted by mini-css-extract-plugin
export var copyable = "_d-1";
export var explainable = "_d-0";
export var negative = "_d-2";
export var positive = "_d-3";